"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JobsHandler = void 0;

var JobsHandler = /*#__PURE__*/function () {
  function JobsHandler() {
    _classCallCheck(this, JobsHandler);

    this.eventListeners = [];
  }

  _createClass(JobsHandler, [{
    key: "attachEventListener",
    value: function attachEventListener(eventListener) {
      this.eventListeners.push(eventListener);
    }
  }, {
    key: "notifyEvent",
    value: function notifyEvent(event, value) {
      this.eventListeners.forEach(function (eventListener) {
        eventListener(event, value);
      });
    }
  }]);

  return JobsHandler;
}();

exports.JobsHandler = JobsHandler;